import "aos/dist/aos.css";
import React, { useEffect, useState } from 'react';
import { IoWarning } from "react-icons/io5";
import { LuArrowRight, LuCalendarDays, LuMapPin } from "react-icons/lu";
import { Link } from "react-router-dom";
import "../../css/items.scss";
import { getPricingRows } from "../meetings/meetingPricing";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import "./events.scss";

const Events = ({ data, language }) => {

  const [allItems, setAllItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);

    serverInstance.get("/app/events")
      .then(res => {
        let data = res.data.items
        data.sort((a, b) => new Date(b.dt).getTime() - new Date(a.dt).getTime())
        setAllItems(data)
        setErrorMsg("");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })
  }, []);

  return (
    <div id="events" className='items-container'>

      {loading ? <Dimmer /> : null}

      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </section>

      {errorMsg ? <div className="error-msg">
        <IoWarning />
        &nbsp;
        {errorMsg}
      </div> : null}

      <section className="events col-11">
        {allItems.length > 0 ?
          allItems.map((item) => {
            const detailPath = "/event/" + item.id;
            const hasRegistrationPricing = getPricingRows(item, { allowDiscountOnly: true }).length > 0;
            const formattedDate = item.dt
              ? new Date(item.dt).toLocaleString('mn-MN', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })
              : "";

            return (
              <article key={"event-" + item.id} className='event-item'>
                <Link className="event-img" to={detailPath} aria-label={item.title}>
                  <img
                    src={`https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`}
                    alt={item.title}
                  />
                </Link>
                <div className='event-info'>
                  <Link className="event-name" to={detailPath}>
                    {item.title}
                  </Link>
                  {item.description ? (
                    <div className="event-desc max-line-2">
                      {item.description}
                    </div>
                  ) : null}
                  <div className="event-meta">
                    {item.location ? (
                      <div className="event-location">
                        <LuMapPin aria-hidden="true" />
                        <span>{item.location}</span>
                      </div>
                    ) : null}
                    {formattedDate ? (
                      <div className="event-time">
                        <LuCalendarDays aria-hidden="true" />
                        <span>{formattedDate}</span>
                      </div>
                    ) : null}
                  </div>
                  <div className="event-actions">
                    <Link className="archive-card-link" to={detailPath}>
                      <span>{data.open}</span>
                      <LuArrowRight aria-hidden="true" />
                    </Link>
                    {hasRegistrationPricing ? (
                      <Link className="event-register-card-link" to={`/event/register?event_id=${item.id}`}>
                        {data.register || data.registerButton || (language ? "Register" : "Бүртгүүлэх")}
                      </Link>
                    ) : null}
                  </div>
                </div>
              </article>
            );
          })
          :
          <div className='archive-empty-state'>
            {data.noData}
          </div>
        }
      </section>
    </div>
  );
};
export default Events;
